import EditorConstants from '../constants/editor-constants'
import AppConstants from '../constants/app-constants'
import AppDispatcher from '../dispatcher/app-dispatcher'

const PhotoorganiseActions = {
	toggleImageSelect: function(image) {
		AppDispatcher.handleViewAction({
			actionType: 'toggleImageSelect',
			image: image
		});
	},
	selectImages: function(imageList) {
		AppDispatcher.handleViewAction({
			actionType: 'selectImages',
			imageList: imageList
		});
	},
	deselectImages: function(imageList) {
		AppDispatcher.handleViewAction({
			actionType: 'deselectImages',
			imageList: imageList
		});
	},
	toggleImageImported: function(imageId) {
		AppDispatcher.handleViewAction({
			actionType: 'toggleImageImport',
			imageId: imageId
		});
	},
	deleteSelection: function() {
		AppDispatcher.handleViewAction({
			actionType: 'deleteSelection'
		});
	},
	setSelectedView: function(data) {
		AppDispatcher.handleViewAction({
			actionType: 'setSelectedView',
			data: data
		});
	},
	shiftSelect:  function(imageId, photoList) {
		AppDispatcher.handleViewAction({
			actionType: 'shiftSelect',
			imageId: imageId,
			photoList: photoList
		});
	},
	setCollectionsData: function (data) {
		AppDispatcher.handleViewAction({
			actionType: 'setCollectionsData',
			data: data
		});
	},
	setEventsData: function (data) {
		AppDispatcher.handleViewAction({
			actionType: 'setEventsData',
			data: data
		});
	},
	setTimelineData: function (data) {
		AppDispatcher.handleViewAction({
			actionType: 'setTimelineData',
			data: data
		});
	}


};

export default PhotoorganiseActions;
